import jsQR from "jsqr";
import { useRef, useEffect } from "react";

export const QrReader = (props) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const initializedRef = useRef(false);
    const timeoutIdRef = useRef();

    const {
        width = 300,
        height = 300,
        interval = 200,
        onRead = _ => { }
    } = props;

    useEffect(() => {
        if (!initializedRef.current) {
            // リアカメラを取得
            const constraints = {
                video: {
                    facingMode: 'environment',
                    width: { ideal: width },
                    height: { ideal: height }
                }
            };
            navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    // video要素でカメラの映像を再生
                    const video = videoRef.current;
                    if (video) {
                        video.srcObject = stream;
                        readQr();
                    }
                })
                .catch(err => console.error('An error occurred while accessing media devices: ', err));
        }
        return () => {
            // 開発中にStrictModeで複数回useEffectが呼ばれるため初期化済みフラグで1回だけ行われるよう対応
            initializedRef.current = true;
            // タイマー、カメラ停止
            clearTimeout(timeoutIdRef.current);
            videoRef?.current?.srcObject?.getTracks()?.forEach(track => track.stop());
        }
    }, []);

    const readQr = () => {
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (video && canvas) {
            const context = canvas.getContext('2d', { willReadFrequently: true });
            if (context) {
                context.drawImage(video, 0, 0, width, height);
                const image = context.getImageData(0, 0, width, height);
                const qrData = jsQR(image.data, image.width, image.height, { inversionAttempts: 'dontInvert' });
                if (qrData && qrData.data) {
                    onRead(qrData.data);
                    return;
                }
            }
        }
        timeoutIdRef.current = setTimeout(readQr, interval);
    }

    return (
        <div style={{ position: 'relative', width: width, height: height }}>
            <video ref={videoRef} autoPlay muted playsInline style={{ position: 'absolute', top: 0, left: 0, width: width, height: height, zIndex: 50 }} />
            <canvas ref={canvasRef} width={width} height={height} style={{ position: 'absolute', top: 0, left: 0 }} />
        </div>
    );
};
